import { render, staticRenderFns } from "./ChangePasswordCard.vue?vue&type=template&id=986685d2"
import script from "./ChangePasswordCard.vue?vue&type=script&lang=js"
export * from "./ChangePasswordCard.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordCard.vue?vue&type=style&index=0&id=986685d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports